import React from "react";
import { Observable } from "rxjs";

export interface ISkeletonProps {
  /** not implemented */
  waitFor?: Observable<unknown> | Promise<unknown> | unknown;
  /** not implemented */
  children?: React.ReactNode;
  [key: string]: unknown;
}

const Skeleton = (props: ISkeletonProps) => {
  const { waitFor, children, ...childProps } = props;

  if (!childProps.className) {
    childProps.className = "skeleton";
  }

  return <div {...childProps}>{children}</div>;
};

export default Skeleton;
